import request from '../request';
const serviceName = '/flow';

/// 汇总待办信息
export function todoTotal() {
  return request(`${serviceName}/history/list`, {
    method: 'GET',
  });
}
